var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iframe--wrapper",style:(_vm.lineStyle)},[(_vm.linkUrl)?_c('iframe',{attrs:{"src":_vm.linkUrl,"frameborder":"0"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }